import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

const ModalConfirmarExclusao = ({
  aberto,
  itens,
  nomeUsuario,
  onConfirmar,
  onCancelar,
}) => {
  const listaExibida = itens ? itens.slice(0, 10) : [];
  const restante = itens && itens.length > 10 ? itens.length - 10 : 0;
  const total = itens ? itens.length : 0;
  const multiUsuario = !nomeUsuario;
  const titulo = multiUsuario
    ? 'Desvincular ' + total + ' vínculo(s)?'
    : 'Desvincular ' + total + ' conta(s) do usuário ' + nomeUsuario + '?';

  return (
    <Modal show={aberto} onHide={onCancelar} centered>
      <Modal.Header
        closeButton
        style={{ backgroundColor: '#0747a6', color: '#fff' }}
      >
        <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
          {titulo}
        </Modal.Title>
        <style>{'.modal-header .close { color: #fff; opacity: 1; }'}</style>
      </Modal.Header>
      <Modal.Body>
        {listaExibida.length > 0 && (
          <ul className="mb-2 pl-3" style={{ fontSize: '0.9rem' }}>
            {listaExibida.map((item) => (
              <li key={item.codigo_usuario + '_' + item.codigo_conta}>
                {item.codigo_conta} — {item.nome_conta || '-'}
                {multiUsuario && item.nome_usuario ? ' (' + item.nome_usuario + ')' : ''}
              </li>
            ))}
          </ul>
        )}
        {restante > 0 && (
          <p className="text-muted" style={{ fontSize: '0.85rem' }}>
            ... e mais {restante} conta(s).
          </p>
        )}
        <Alert variant="warning" className="mb-0" style={{ fontSize: '0.85rem' }}>
          Esta ação não pode ser desfeita.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onCancelar}>
          Cancelar
        </Button>
        <Button variant="danger" size="sm" onClick={onConfirmar}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmarExclusao;
